<script>
  import headers from '../data/headers-private-room';

  import BattlegroundsDialog from '@/views/app/dashboard/battleground/components/BattlegroundsDialog.vue';
  import DataTableGolden from '@/components/tables/DataTableGolden.vue';
  import DataTableGoldenMobile from '@/components/tables/DataTableGoldenMobile.vue';
  import { GameLauncher } from '@/mixins/game-launcher';

  export default {
    name: 'PrivateRoom',

    mixins: [GameLauncher],

    components: {
      DataTableGolden,
      DataTableGoldenMobile,
      BattlegroundsDialog,
      GameHistoryPrivate: () => import('@/views/app/dashboard/battleground/components/GameHistoryPrivate.vue'),
    },

    data: () => ({
      crown: require('@/assets/svgs/crown.svg'),
      headers,
      // items,
      gamesAvailable: {
        838: 'Dragonstone',
        856: 'Dragonstone',
        859: 'Mission Amazon',
        862: 'Mission Amazon',
        864: 'Max Blast Champs',
        866: 'Sector X',
        867: 'Sector X',
        875: 'Triple Max Blast',
        1: 'Multiplinko',
        2: 'Roll Or Hold',
        5: 'Rolling 21',
        6: 'MultiMines',
      },
      buyInValues: {
        1: 'Rumble',
        2000: 'Rumble',
        2: 'Frenzy',
        4000: 'Frenzy',
        5: 'Rage',
        10000: 'Rage',
        20: 'Fury',
        40000: 'Fury',
        50: 'Storm',
        100000: 'Storm',
        100: 'Chaos',
        200000: 'Chaos',
      },

      friendsListVisibleForRoomId: null,

      showDialog: false,
      isMobile: false,
    }),

    computed: {
      selectedTab() {
        return this.tab === 'public' ? 'GameHistoryPublic' : 'GameHistoryPrivate';
      },
      items() {
        return [...(this.$store.getters.getPrivateRoomsList || [])].sort((a, b) => {
          // First, sort by active status
          if (a.active !== b.active) {
            return b.active - a.active;
          }

          return new Date(b.dateCreated) - new Date(a.dateCreated);
        });
      },
      currentUserId() {
        return this.$store.getters.getCurrentUserID;
      },
      onlineUsers() {
        return this.$store.getters.getOnlineUsersFromList || [];
      },
    },

    watch: {
      items: {
        deep: true,
        immediate: true,
        handler(value) {
          const displayNames = (value || []).reduce((acc, item) => {
            if (!item.active) {
              return acc;
            }
            return acc.concat(
              [
                ...Object.values(item.playersInvited || {}).map(
                  (invite) => invite.displayName !== undefined && invite.displayName,
                ),
                item.hostDisplayName !== undefined && item.hostDisplayName,
              ].filter((displayName) => displayName),
            );
          }, []);

          const uniqueDisplayNames = [...new Set(displayNames)];

          this.$store.dispatch('getOnlinePlayersFromList', uniqueDisplayNames);
        },
      },
    },

    created() {
      this.$store.dispatch('getPrivateRoomsByUser', { gameId: 1 });
      this.$store.dispatch('getPrivateRoomsByUser', { gameId: 2 });
      this.$store.dispatch('getPrivateRoomsByUser', { gameId: 5 });
      this.$store.dispatch('getPrivateRoomsByUser', { gameId: 6 });

      this.$store.dispatch('getCurrentUserID');

      this.setResizeListener();
      this.setIsMobileResolution();
    },

    beforeDestroy() {
      this.removeResizeListener();
    },

    methods: {
      isUnityGame(gameId) {
        if (this.$store.getters.getActiveGames.length > 0) {
          const game = this.$store.getters.getActiveGames.find((game) => game.key === String(gameId));
          return game ? game.unityGame : false;
        } else {
          return false;
        }
      },
      setResizeListener() {
        window.addEventListener('resize', this.handleResize);
      },
      removeResizeListener() {
        window.removeEventListener('resize', this.handleResize);
      },
      setIsMobileResolution() {
        this.isMobile = document.documentElement.clientWidth <= 768;
      },
      handleResize() {
        this.setIsMobileResolution();
        this.$forceUpdate();
      },

      getTypeOfRoom({ buyIn }) {
        const value = buyIn / 100;

        return this.buyInValues[value];
      },
      showParticipants({ privateRoomId }) {
        let value = privateRoomId;

        if (!privateRoomId || privateRoomId === this.friendsListVisibleForRoomId) {
          value = null;
        }

        this.friendsListVisibleForRoomId = value;
      },
      /**
       * @param gameId
       * @param privateRoomId
       * @param customRoomId
       * @param buyIn
       * @param hostId
       * @param bankId
       * @returns {Promise<void>}
       */
      async enterRoom({ gameId, privateRoomId, buyIn, hostId, bankId }) {
        const addFriendUrl = process.env.VUE_APP_ADD_FRIEND_URL;

        const { balance } = this.$store.getters.getUserTotalBalance;
        const hasBalance = bankId === 6275 ? balance.MQC > 0 : balance.MMC > 0;
        let isBalanceSufficient = bankId === 6275 ? balance.MQC >= (buyIn || 0) : balance.MMC >= (buyIn || 0);

        if (!hasBalance || !isBalanceSufficient) {
          this.$store.dispatch('showConfirmDialog', {
            title: 'Insufficient balance',
            text: 'In order to accept this invitation, please deposit to your balance.',
            yesText: 'Deposit Now',
            noText: 'Cancel',
            callback: () => {
              this.$store.dispatch('setWalletDialog', {
                value: true,
                tab: 'purchase',
              });
            },
          });
          return;
        }
        if (!this.isUnityGame(gameId)) {
          await this.enterPrivateRoom(privateRoomId, 'CAF', addFriendUrl);
        } else {
          const homeUrl = process.env.VUE_APP_CHALLENGE_URL;
          await this.launchGameUnity(
            gameId,
            homeUrl,
            addFriendUrl,
            'extended',
            buyIn,
            false,
            hostId,
            privateRoomId,
            bankId,
          );
        }
      },
      async closeRoom({ privateRoomId, bankId, customRoomId, gameId }) {
        await this.$store.dispatch('requestGameplayTokenAs');
        const token = this.$store.getters.getGameplayToken;

        const data = {
          privateRoomId: privateRoomId,
          privateRoomToken: token,
          bankId: bankId,
          gameId,
          isUnity: customRoomId ? false : true,
        };

        await this.$store.dispatch('deactivatePrivateRoom', data);
        if (data.isUnity) {
          await this.$store.dispatch('getPrivateRoomsByUser', { gameId: gameId });
        }
      },
      canCloseRoom(item) {
        return !this.amIKicked(item) && item.active && this.currentUserId === item.hostId;
      },
      getUsersInRoom(item) {
        return Object.values(item.playersInvited || {}).filter((i) => i.inviteAccepted);
      },
      amIKicked(room) {
        const me = Object.values(room.playersInvited || {}).find((i) => i.displayName === this.userDetails.displayName);

        return me && me.status === 'KICKED';
      },
      getFormattedBuyInValue(value) {
        if (value) {
          return (parseInt(value) / 100).toLocaleString();
        }

        return '0';
      },
    },
  };
</script>

<template>
  <div class="py-2">
    <component
      :is="isMobile ? 'data-table-golden-mobile' : 'data-table-golden'"
      :headers="headers"
      :items="items"
      :is-mobile="isMobile"
      has-actions
      @click="showParticipants({})"
    >
      <template #item.roomName="{ item }">
        <div
          :class="{
            'ml-12': $vuetify.breakpoint.width > 768,
            'font-italic': $vuetify.breakpoint.xsOnly,
          }"
          class="d-flex flex-wrap"
        >
          <span>{{ gamesAvailable[item.gameId] }}</span>
          <span class="mx-1 font-weight-400">|</span>
          <span>{{ getTypeOfRoom(item) }}</span>
          <span class="mx-1 font-weight-400">|</span>
          <span>{{ getFormattedBuyInValue(item.buyIn) }}</span>
        </div>
      </template>
      <template #item.customRoomId="{ item }">
        <div>
          <span
            class="px-3"
            :class="{
              'ml-12': $vuetify.breakpoint.width > 768,
              'font-italic': $vuetify.breakpoint.xsOnly,
            }"
          >
            #{{
              item.customRoomId
                ? String(item.customRoomId).padStart(5, '0')
                : String(item.privateRoomId).padStart(5, '0').substring(0, 5)
            }}
          </span>
        </div>
      </template>
      <template #item.status="{ item }">
        <div :class="item.active ? 'green-light--text' : 'disabled--text'">
          <span
            v-if="amIKicked(item)"
            class="text-uppercase px-3 red-bright--text"
            :class="{ 'ml-12': $vuetify.breakpoint.width > 768 }"
          >
            KICKED
          </span>
          <span v-else class="text-uppercase px-3" :class="{ 'ml-12': $vuetify.breakpoint.width > 768 }">
            {{ item.active ? 'ACTIVE' : 'CLOSED' }}
          </span>
        </div>
      </template>
      <template #item.members="{ item }">
        <div v-if="item.active" class="friends-container" @click.stop="showParticipants(item, item)">
          <div class="friends-list">
            <ul>
              <li>
                <div class="d-flex align-center justify-start">
                  <div
                    class="status"
                    :class="{ online: onlineUsers.includes(item.hostDisplayName) }"
                    style="margin-right: 3px; margin-top: 4px"
                  />
                  <span class="max-content mr-2 ml-1 player-name host">
                    {{ item.hostDisplayName }}
                  </span>
                  <v-img v-reload-on-fail :src="crown" max-width="13px" max-height="13px" />
                </div>
              </li>
              <li v-for="(user, index) in getUsersInRoom(item)" class="d-flex align-center" :key="index">
                <div
                  :class="{
                    online: onlineUsers.includes(user.displayName),
                    unaccepted: !user.inviteAccepted,
                  }"
                  class="status mt-1"
                />
                <div class="d-flex align-center justify-space-between w-full">
                  <span :class="['mx-2', 'player-name', { kicked: user.status === 'KICKED' }]">
                    {{ user.name || user.displayName }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-else />
      </template>

      <template #actions="{ item }">
        <div class="actions-container" :class="{ 'ml-5': $vuetify.breakpoint.width > 768 }">
          <action-button>
            <template #action="{ loading, clickHandler }">
              <v-btn
                color="gold"
                class="enter-room-btn font-size-18 font-weight-superbold px-6"
                :loading="loading"
                :class="{ disabled: amIKicked(item) }"
                :disabled="!item.active || amIKicked(item)"
                height="36"
                @click="clickHandler(enterRoom, item)"
              >
                ENTER
              </v-btn>
            </template>
          </action-button>
          <action-button>
            <template #action="{ loading, clickHandler }">
              <v-btn
                color="red-bright"
                :loading="loading"
                :class="{ disabled: amIKicked(item) || canCloseRoom(item) }"
                :disabled="!item.active || !canCloseRoom(item)"
                class="close-room-btn font-size-18 font-weight-superbold"
                height="36"
                @click="clickHandler(closeRoom, item)"
              >
                CLOSE ROOM
              </v-btn>
            </template>
          </action-button>
        </div>
      </template>
    </component>
  </div>
</template>

<style lang="scss" scoped>
  .actions-container {
    .close-room-btn[disabled],
    .enter-room-btn[disabled] {
      background-color: #4d4d4d !important;
      color: black !important;
    }
  }

  .actions-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 1;

    .v-btn {
      width: 120px;
      min-height: 36px;
      height: 100%;
    }

    @media screen and (min-width: 768px) {
      flex-direction: column;
      gap: 10px;
    }
  }

  .friends-container {
    width: 100%;
    position: relative;
    cursor: pointer;

    .friends-list {
      width: calc(100% + -30px);
      border-radius: 0 0 15px 15px;
      z-index: 1;

      ul {
        list-style: none;
        padding-left: 0;
        transition: 10s;

        li {
          text-align: left !important;

          .status {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            display: inline-block;
            margin-bottom: 2px;
            // Initially offline
            background: var(--v-red-bright-base);

            &.online {
              background: var(--v-green-light-base);
            }

            &.unaccepted {
              background: var(--v-red-bright-base);
            }
          }

          .player-name:not(.host) {
            font-weight: 400;
          }

          .player-name {
            font-size: 14px;

            &.kicked {
              color: grey;
              opacity: 0.5;
            }
          }

          .status:not(.online) + .player-name {
            color: grey;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .friends-container {
      .friends-list {
        //top: 32px;
        width: 100%;
        left: initial;
      }
    }

    .actions-container {
      width: 100%;
      gap: 12px;
      justify-content: center;

      .v-btn {
        width: calc(30% - 6px);
        min-width: 120px;
        margin: 0 !important;
        border-radius: 8px !important;
      }
    }
  }
</style>
